<template>
  <FileUploadSlot @update:file="uploadFile">
    <template v-slot:activator="{ on }">
      <v-expansion-panels>
        <v-expansion-panel v-on="on" class="rounded-4" readonly :disabled="loading || disabled">
          <v-expansion-panel-header
            ripple
            style="height: 64px"
            class="font--m-3"
            :class="{ loading }"
          >
            <div>
              <h3 class="font--m-3">{{ loading ? '서류를 제출중입니다' : buttonText }}</h3>
              <p
                v-if="buttonDescription"
                class="mb-0 font--m-7 font-weight-bold"
                :class="{ 'color--nice-grey': !disabled }"
                style="margin-top: 3px"
              >
                {{ buttonDescription }}
              </p>
            </div>
            <template v-slot:actions>
              <v-icon v-if="!loading && disabled"> </v-icon>
              <v-icon v-else-if="!loading"> mdi-plus </v-icon>
              <v-progress-circular
                v-else
                indeterminate
                color="grey"
                size="21"
                width="2"
              ></v-progress-circular>
            </template>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </FileUploadSlot>
</template>

<script>
import RequestFileUploadMixin from './RequestFileUploadMixin.js'

export default {
  props: {
    buttonText: {
      type: String,
      default: '서류',
    },

    buttonDescription: {
      type: String,
    },

    title: {
      type: String,
    },
  },
  mixins: [RequestFileUploadMixin],
}
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-header .v-expansion-panel-header__icon {
  transform-origin: none;
  display: block !important;
}
</style>
